import React from 'react';
import Button from '@components/atoms/Button';

const PaginationButton = ({
  value = ``,
  isActive = false,
  onClick = () => {}
}) => (
  <Button
    size="ellipsedSmall"
    textColor={isActive ? `colours.darkPurple` : `white`}
    color={isActive ? `colours.darkPurple` : `white`}
    bgColor={isActive ? `white` : `colours.darkPurple-muted`}
    px="0 !important"
    width={{ base: 12, md: 14 }}
    _hover={
      isActive
        ? {
            cursor: `default`
          }
        : {
            textColor: `colours.darkPurple`,
            color: `colours.darkPurple`,
            bg: `white`
          }
    }
    _focus={
      isActive
        ? {
            cursor: `default`
          }
        : {
            textColor: `colours.darkPurple`,
            color: `colours.darkPurple`,
            bg: `white`
          }
    }
    onClick={onClick}>
    {value}
  </Button>
);

export default PaginationButton;
